import { ModelIcon } from '../ModelIcon';

export type ModelSwitchStatus = 'completed' | 'failed' | 'pending';

export type ModelSwitchItem = {
  id: string;
  name: string;
  iconSvg?: string | null;
  status?: ModelSwitchStatus | null;
};

export function ModelSwitch({
  items,
  activeId,
  onChange,
}: {
  items: ModelSwitchItem[];
  activeId: string | null;
  onChange: (id: string) => void;
}) {
  if (items.length === 0) return null;

  return (
    <div className="d-flex flex-wrap align-items-center justify-content-end gap-1">
      {items.map((item) => {
        const selected = item.id === activeId;
        return (
          <button
            key={item.id}
            type="button"
            title={item.name}
            aria-label={item.name}
            aria-pressed={selected}
            onClick={() => onChange(item.id)}
            className={`btn btn-sm shadow-none d-inline-flex align-items-center justify-content-center gap-1 rounded-2 px-2 border ${
              selected
                ? 'border-primary bg-white dark__bg-1100 text-900 fw-semibold'
                : 'border-200 bg-body-tertiary text-700'
            }`}
            style={{ height: '1.75rem', lineHeight: 1, paddingTop: 0, paddingBottom: 0 }}
          >
            <ModelIcon svg={item.iconSvg} name={item.name} size={16} />
            <span className="fs--2 d-none d-md-inline">{item.name}</span>
            {item.status === 'completed' ? (
              <span
                className="rounded-circle bg-success flex-shrink-0"
                style={{ width: 5, height: 5 }}
                aria-hidden
              />
            ) : null}
            {item.status === 'failed' ? (
              <span
                className="rounded-circle bg-danger flex-shrink-0"
                style={{ width: 5, height: 5 }}
                aria-hidden
              />
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
